import React from 'react';
import { useDispatch } from 'react-redux';
import { sendVulnToWHD } from 'store/Settings/solarWindsActions';
import first from 'lodash/first';
import { useIntl } from 'react-intl';
import {
  Wrapper, Title, Subtitle, Footer, Close, Save, Blue
} from './styled';

const SolarWinds = ({ onClose, vulnsSelected, vulnId, isVulnDetailOpen, entity }) => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const onSave = () => {
    dispatch(sendVulnToWHD(vulnsSelected, vulnId, isVulnDetailOpen, entity));
    onClose();
  };

  const getText = () => ((vulnsSelected.length === 1) ? first(vulnsSelected).name : `${vulnsSelected.length} vulnerabilities`);

  return (
    <Wrapper>
      <Title>{ intl.formatMessage({ id: 'sendToTool.solarWinds.title' }) }</Title>
      <Subtitle>
        { intl.formatMessage({ id: 'sendToTool.solarWinds.message.youAreSending' }) }
        <Blue>{ getText() }</Blue>
      </Subtitle>
      <Footer>
        <Close onClick={ onClose }>{ intl.formatMessage({ id: 'sendToTool.solarWinds.form.close' }) }</Close>
        <Save onClick={ onSave }>{ intl.formatMessage({ id: 'sendToTool.solarWinds.form.save' }) }</Save>
      </Footer>
    </Wrapper>
  );
};

export default SolarWinds;
